import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCModal, RCCGrid, RCCRefModalProps, RCCHookToast, RCCServicesApi, RCCHTMLTextEditor, RCCSwitch } from "react-common-components";
import { useForm } from "react-hook-form";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import formatDate from "src/utils/formatDate";
import IRefModalTermsUse, { ITermsOfUse } from "./interface";

const ModalTermsUse: React.ForwardRefRenderFunction<IRefModalTermsUse> = (_, ref) => {
	const { translate, currentLanguage } = useTranslation();
	const { addToast } = RCCHookToast();
	const { setLoading } = useLoaderBackdrop();

	const modalTermsUseRef = useRef<RCCRefModalProps>(null);
	const [onlyView, setOnlyView] = useState(false);
	const userId = useRef(0);

	const onCallbackFunction = useRef<Function>(() => {});
	const [termsOfUse, setTermsOfUse] = useState<ITermsOfUse[]>([]);
	const [termsOfUseContent, setTermsOfUseContent] = useState<string>("");
	const {control, register, handleSubmit} = useForm();

	const openModal = async () => {
		try{
			const { data } = await RCCServicesApi.getRequest({
				method: "TermsUse/GetAllValids"
			});
			setTermsOfUse(data);
			let content = "";
			data.forEach((terms: ITermsOfUse) => {
				content += terms.tea001Conteudo;
			});
			setTermsOfUseContent(content);
			modalTermsUseRef.current?.openModal();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar termo de uso"), addToast);
		}
	};

	const openModalViewTermsUse = async () => {
		setLoading(true);
		setOnlyView(true);
		await openModal();
		setLoading(false);
	};

	const openModalAcceptTermsUse = async (efa005Id: number, onCallback: Function) => {
		setOnlyView(false);
		userId.current = efa005Id;
		onCallbackFunction.current = () => onCallback();
		openModal();
	};

	const onSubmit = async (data: any) => {
		if(!data.agree){
			addToast({
				color: "yellow",
				description: translate("Você tem que marcar a opção concordando com os termos de uso"),
				title: translate("Atenção")
			});
			return;
		}
		try{
			await RCCServicesApi.postRequest({
				method: "TermsUse/Accept",
				body: {
					TermsOfUse: termsOfUse,
					Efa005Id: userId.current
				}
			});
			modalTermsUseRef.current?.closeModal();
			onCallbackFunction.current();
		}catch(err){
			standardErrorMessages(err, translate("Erro ao aceitar os termos de uso"), addToast);
		}
	};

	useImperativeHandle(ref, () => ({
		openModalViewTermsUse,
		openModalAcceptTermsUse
	}));

	return (
		<RCCModal
			ref={modalTermsUseRef}
			header={{
				title: `${translate("Termos de uso")}/${translate("Política de privacidade")}`,
				subtitle: formatDate(new Date(), currentLanguage),
				icon: {
					name:  "list"
				}
			}}
			onSubmit={handleSubmit(onSubmit)}
			footer={{
				buttonLoadingText: translate("Carregando"),
				saveButtonText: translate("Aceitar"),
				cancelButtonText: translate("Fechar"),
				showSaveButton: !onlyView
			}}
			hiddenCloseButton={!onlyView}
		>
			<RCCGrid container item justifyContent="center" alignItems="center" style={{ height: "100%" }}>
				{termsOfUseContent && termsOfUseContent.length > 0 && 
					<RCCHTMLTextEditor 
						name="tea001Conteudo"
						label={" "}
						control={control}	
						defaultValue={termsOfUseContent}	
						disabled
						styleInline={`
							padding: 0px;
							>span{
								display: none;
							}
							.rdw-editor-toolbar{
								display: none;
							}
							.rdw-editor-main{
								border: none;
								cursor: auto;
							}
						`}
					/>
				}
				{!onlyView && (
					<RCCSwitch 
						name="agree"
						register={register}
						label={translate("Eu li e concordo com os termos de uso")}
						labelPosition="end"
					/>
				)}
			</RCCGrid>
		</RCCModal>
	);
};

export default React.forwardRef(ModalTermsUse);
